export default __webpack_public_path__ + "static/media/8.a87fafd7.jpg";